export const fantasyGuildImage = (theme, room, thumbnail) => '/guild-home-v2/'+theme+'/'+room+(thumbnail?'-small':'')+'.webp';
